<template>
    <div class="carousel carousel-dark slider">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <img :src="currentImage" class="d-block slider-img w-100" alt="Image" />
            </div>
        </div>
        <div class="carousel-indicators" v-if="images.length > 1">
            <button v-for="(images, index) in images" :key="index" type="button"
                :class="{ active: currentImageIndex === index }" :ref="'button-' + index"
                data-bs-target="#carouselExampleDark" @click="changeImage(index)" />
        </div>
    </div>
</template>

<script>
import image1 from '@/assets/images/screens/2.png'
import image2 from '@/assets/images/screens/1.png'
export default {
    props: ['sliderImages', 'isCustomerLoginPage'],
    data() {
        return {
            images: [image1, image2, image1],
            isActive: false,
            currentImageIndex: 0,
            intervalId: null,
        }
    },
    computed: {
        currentImage() {
            return this.images[this.currentImageIndex]
        },
    },
    watch: {
        sliderImages: {
            immediate: true,
            handler: function (val) {

                if (this.isCustomerLoginPage && val.length >0) {
                    this.images = val
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.startInterval()
    },
    methods: {
        startInterval() {
            this.intervalId = setInterval(() => {
                this.currentImageIndex =
                    (this.currentImageIndex + 1) % this.images.length
            }, 3000)
        },
        stopInterval() {
            clearInterval(this.intervalId)
        },
        changeImage(index) {
            this.currentImageIndex = index
            this.stopInterval()
        },
    },
    beforeDestroy() {
        this.stopInterval()
    },
}
</script>
